// Dynamic iframe height adjustment utility
// This allows embedded content to automatically resize the iframe

import React from "react";

const allowedDomains = [    
    "https://fabconcept.no",
    "https://dev-coupon.digifront.biz",
    "https://kuponger.fabconcept.no",
    "https://easytracknow.com",
    "https://coupon.digifront.biz", // Added from your example
];

// Function to send height and width to parent window
const sendHeightToParent = () => {
    try {
        // Get the actual content height
        const height = Math.max(
            document.body.scrollHeight,
            document.body.offsetHeight,
            document.documentElement.clientHeight,
            document.documentElement.scrollHeight,
            document.documentElement.offsetHeight
        );

        // Get the actual content width
        const width = Math.max(
            document.body.scrollWidth,
            document.body.offsetWidth,
            document.documentElement.clientWidth,
            document.documentElement.scrollWidth,
            document.documentElement.offsetWidth
        );

        // Send height and width to all trusted domains
        allowedDomains.forEach((domain) => {
            window.parent.postMessage(
                {
                    type: "iframe-resize",
                    height: height,
                    width: width,
                    url: window.location.href,
                },
                domain
            );
        });

        console.log("Height and width sent to parent:", { height, width });
    } catch (error) {
        console.log("Could not send dimensions to parent:", error);
    }
};

// Enhanced iframe check with height adjustment
const checkIframeEmbedding = () => {
    try {
        // Check if we're in an iframe
        if (window !== window.top) {
            const parentOrigin = window.location.origin;
            const referrer = document.referrer;

            console.log("Parent origin:", parentOrigin);
            console.log("Referrer:", referrer);

            // Check if the referrer domain is in our allowed list
            const isAllowed = allowedDomains.some(
                (domain) =>
                    referrer.startsWith(domain) ||
                    parentOrigin.startsWith(domain)
            );

            if (!isAllowed) {
                console.warn(
                    "Iframe embedding not allowed from this domain:",
                    referrer
                );
            } else {
                console.log("Iframe embedding allowed from:", referrer);

                // Set up height adjustment for allowed domains
                setupHeightAdjustment();
            }
        }
    } catch (error) {
        console.log("Cross-origin iframe detected");
    }
};

// Set up automatic height adjustment
const setupHeightAdjustment = () => {
    // Send height on load
    window.addEventListener("load", sendHeightToParent);

    // Send height on resize
    window.addEventListener("resize", sendHeightToParent);

    // Send height when content changes (using MutationObserver)
    const observer = new MutationObserver(() => {
        // Debounce the height sending to avoid too many calls
        clearTimeout(window.heightTimeout);
        window.heightTimeout = setTimeout(sendHeightToParent, 100);
    });

    // Observe changes to the document body
    observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ["style", "class"],
    });

    // Send initial height
    setTimeout(sendHeightToParent, 500);
};

// React hook for iframe functionality
export const useIframeCheck = () => {
    React.useEffect(() => {
        checkIframeEmbedding();
    }, []);
};

// Export the height sending function for manual use
export const sendHeight = sendHeightToParent;

export default checkIframeEmbedding;
